import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessConsultaOtorgamientos } from '../utils/gestionCampanaAccess'

const RequireConsultaOtorgamientosAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessConsultaOtorgamientos(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequireConsultaOtorgamientosAccess
